// Main entry point
import ReactDOM from 'react-dom/client';
// Auth-Store sofort laden → Hydration (User/Plan aus Token/Cache) vor erstem React-Render, weniger Flackern
import './stores/authStore';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';
import './styles/mobile.design-system.css';
import './styles/fyle-fonts.css';
import { initializeConsent } from './utils/consent';
import { isBenignBrowserMessagePortError } from './utils/benignClientErrors';

// Initialize Sentry before rendering
import { initSentry } from './utils/sentry';
initSentry();
initializeConsent();

// Global error handler for chunk load errors
window.addEventListener('error', (event) => {
  if (isBenignBrowserMessagePortError(event.error) || isBenignBrowserMessagePortError(event.message)) {
    event.preventDefault();
    return;
  }

  const error = event.error || event.message;
  const isChunkError = 
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Loading CSS chunk') ||
    event.filename?.includes('assets/js/') ||
    event.filename?.includes('assets/css/');
  
  if (isChunkError) {
    console.error('❌ Chunk load error detected:', {
      message: error?.message || event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
    
    // Show user-friendly error and offer to reload
    const shouldReload = window.confirm(
      'A required file failed to load. This usually happens after a deployment.\n\n' +
      'Would you like to reload the page to get the latest version?'
    );
    
    if (shouldReload) {
      // Clear cache and reload
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }
      window.location.reload();
    }
    
    // Prevent default error handling
    event.preventDefault();
  }
});

// Handle unhandled promise rejections (chunk load errors)
window.addEventListener('unhandledrejection', (event) => {
  if (isBenignBrowserMessagePortError(event.reason)) {
    event.preventDefault();
    return;
  }

  const error = event.reason;
  const isChunkError = 
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Loading CSS chunk') ||
    error?.type === 'chunk-load-error';
  
  if (isChunkError) {
    console.error('❌ Chunk load error (unhandled rejection):', error);
    
    // Show user-friendly error and offer to reload
    const shouldReload = window.confirm(
      'A required file failed to load. This usually happens after a deployment.\n\n' +
      'Would you like to reload the page to get the latest version?'
    );
    
    if (shouldReload) {
      // Clear cache and reload
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }
      window.location.reload();
    }
    
    // Prevent default error handling
    event.preventDefault();
  }
});

// URL restoration is now handled by URLRestorer component after React Router initializes
// This prevents conflicts and ensures proper client-side navigation without page reloads

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
